// exportShotListToPDF.js
import { jsPDF } from 'jspdf/dist/jspdf.umd.min.js';

const exportShotListToPDF = (projectState, shotListState) => {
  const doc = new jsPDF('landscape', 'pt', 'letter');

  // Title
  doc.setFontSize(20);
  doc.setFont('helvetica', 'bold');
  doc.text(`${projectState.projectTitle || 'Untitled Project'} - Shot List`, 40, 50);

  // Shot list
  const shotList = shotListState || [];
  if (!shotList.length) {
    doc.setFontSize(14);
    doc.setFont('helvetica', 'normal');
    doc.text('No shots available in the shot list.', 40, 80);
    doc.save(`${projectState.projectTitle || 'Untitled'}_ShotList.pdf`);
    return;
  }

  // Determine columns
  const fields = Object.keys(shotList[0]);
  const pageWidth = doc.internal.pageSize.getWidth();  // ~792 in landscape
  const pageHeight = doc.internal.pageSize.getHeight(); // ~612 in landscape
  const leftMargin = 40;
  const topMargin = 70;
  const bottomMargin = 40;
  let currentY = topMargin + 20;
  const headerHeight = 30;
  const lineSpacing = 12;
  const tableWidth = pageWidth - 2 * leftMargin;
  const colCount = fields.length;
  const colWidth = tableWidth / colCount;

  // Draw header row
  const drawHeader = () => {
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(12);
    doc.setLineWidth(0.75);
    doc.setDrawColor(0, 0, 0); // black border

    fields.forEach((field, colIndex) => {
      const xPos = leftMargin + colIndex * colWidth;

      // For each column, set the purple fill color again
      doc.setFillColor(135, 75, 158); // #874B9E
      doc.setTextColor(255, 255, 255); // white text

      // 'DF' = draw + fill. This ensures a visible boundary and color fill
      doc.rect(xPos, currentY, colWidth, headerHeight, 'DF');

      // Now place the text in the cell
      const textX = xPos + 8; 
      const textY = currentY + headerHeight / 1.6;
      doc.text(field, textX, textY);
    });

    currentY += headerHeight;
    // Reset text color/style for table body
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    doc.setTextColor(0, 0, 0);
    doc.setLineWidth(0.5); 
  };

  // Page break logic
  const startNewPage = () => {
    doc.addPage();
    currentY = topMargin;
    drawHeader();
  };

  // Draw initial header
  drawHeader();

  // Render rows
  shotList.forEach((rowData) => {
    // Calculate row height from the tallest cell
    let rowHeight = 0;
    const cellLines = {};

    fields.forEach((field) => {
      const text = rowData[field] ? rowData[field].toString() : '';
      const lines = doc.splitTextToSize(text, colWidth - 10);
      cellLines[field] = lines;
      const neededHeight = lines.length * lineSpacing + 10;
      rowHeight = Math.max(rowHeight, neededHeight);
    });

    // Page break if needed
    if (currentY + rowHeight > pageHeight - bottomMargin) {
      startNewPage();
    }

    // Draw each cell in this row
    fields.forEach((field, colIndex) => {
      const xPos = leftMargin + colIndex * colWidth;
      // 'DF' to draw a black border and fill white background
      doc.setFillColor(255, 255, 255);
      doc.rect(xPos, currentY, colWidth, rowHeight, 'DF');

      let textY = currentY + lineSpacing;
      cellLines[field].forEach((line) => {
        doc.text(line, xPos + 5, textY);
        textY += lineSpacing;
      });
    });

    currentY += rowHeight;
  });

  // Save PDF
  doc.save(`${projectState.projectTitle || 'Untitled'}_ShotList.pdf`);
};

export default exportShotListToPDF;
